import { LinkedFirestoreDocument } from "@/core/modules/firestore/objects/LinkedFirestoreDocument";
import { TransactionType } from "./TransactionType";

import { StringField } from "@/core/fields";

export class LinkedTransactionType extends LinkedFirestoreDocument {
  public name: string | undefined = undefined;

  public constructor(firestoreData?: Record<string, unknown>) {
    super();
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);
  }

  public static createFromTransactionType(transactionType: TransactionType): LinkedTransactionType {
    const linkedTransactionType: LinkedTransactionType = new LinkedTransactionType();
    linkedTransactionType.id = transactionType.id;
    linkedTransactionType.name = transactionType.name;

    return linkedTransactionType;
  }

  public fromFirestore(data: Record<string, unknown>): LinkedTransactionType {
    super.fromFirestore(data);

    this.name = StringField.fromFirestore(data.name);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.name = StringField.toFirestore(this.name);

    return firestoreData;
  }
}
